import {
  ORGANIZATION_ID,
  SITE_URL,
  WEBSITE_ID,
  getContributorRef,
  getPersonNode,
  isPersonContributor,
  toSchemaGraph,
} from "@Pages/Blog/utils/blogSchemaGraph";
import type { EditorialPageData } from "../types";
import { resolveEditorialCanonicalPath } from "../utils/editorialPaths";

const getEditorialPageSchema = (data: EditorialPageData, lang?: string) => {
  const path = resolveEditorialCanonicalPath(data);
  const pageUrl = `${SITE_URL}${lang ? `/${lang}` : ""}${path}`;
  const dateModified = data.hero.lastReviewedAt || undefined;
  const { reviewer } = data;

  const people = reviewer && isPersonContributor(reviewer) ? [getPersonNode(reviewer)] : [];

  return toSchemaGraph([
    {
      "@type": "WebPage",
      "@id": `${pageUrl}#webpage`,
      url: pageUrl,
      name: data.metaTitle,
      ...(data.metaDescription ? { description: data.metaDescription } : {}),
      isPartOf: { "@id": WEBSITE_ID },
      publisher: { "@id": ORGANIZATION_ID },
      ...(dateModified ? { dateModified } : {}),
      reviewedBy: getContributorRef(reviewer),
    },
    {
      "@type": "BreadcrumbList",
      "@id": `${pageUrl}#breadcrumb`,
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
        {
          "@type": "ListItem",
          position: 2,
          name: "Blogs",
          item: `${SITE_URL}${lang ? `/${lang}` : ""}/blog`,
        },
        { "@type": "ListItem", position: 3, name: data.hero.heading || data.metaTitle },
      ],
    },
    ...people,
  ]);
};

export default getEditorialPageSchema;
